import React from "react";
import {Spinner} from "@seismic/mantle";

export const Percent = (props) => {
    
    let color = "success";
    if(props.percent < .25)
        color = "danger";
    else if(props.percent < .50)
        color = "warning";
    
    let percent = Math.trunc(props.percent * 100);
    
    return <span className={`${color}`}>{percent}%</span>
}